import { useEffect, useMemo } from 'react'
import {
  ToolbarResponsiveContext,
  ToolbarResponsiveStore,
} from 'common/Prose/Toolbar/ToolbarBravo/stores/ToolbarResponsiveStore'
import Styles from './WriterFormatToolbarContainer.module.scss'
import { WriterFormatToolBar } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/WriterFormatToolbar'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileWriterToolbar } from 'common/Prose/Toolbar/MobileWriterToolbar/MobileWriterToolbar'
import { FocusModeHidden } from 'components/FocusModeHidden/FocusModeHidden'
import { useMeasure } from 'react-use'

export const WriterFormatToolbarContainer = () => {
  const { isMobile } = useResponsiveDesign()
  const toolbarResponsiveStore = useMemo(() => new ToolbarResponsiveStore(), [])
  const [ref, { width }] = useMeasure<HTMLDivElement>()

  // Monitor the size of the toolbar
  useEffect(() => {
    if (width == null) return
    toolbarResponsiveStore.setToolbarRect({ width })
  }, [toolbarResponsiveStore, width])

  return (
    <FocusModeHidden className={Styles.formatMenuWrapper} ref={ref}>
      <ToolbarResponsiveContext.Provider value={toolbarResponsiveStore}>
        {isMobile ? <MobileWriterToolbar /> : <WriterFormatToolBar />}
      </ToolbarResponsiveContext.Provider>
    </FocusModeHidden>
  )
}
